import React from 'react';
import { animated, useSpring } from 'react-spring';
import { randomIntegerInRange } from 'vrlcm-gui-utils';

interface RectProps {
  y: number;
}

const maxWidth = 200;

export const BootRect: React.FC<RectProps> = props => {
  const { y } = props;

  const spring = useSpring({
    to: async (next: (obj: { width: number }) => { width: number }) => {
      /* eslint-disable-next-line */
      while (1) {
        let randomPercent = randomIntegerInRange(30, 100);
        let altWidth = (maxWidth * randomPercent) / 100;
        await next({
          width: altWidth
        });
        await new Promise(r => setTimeout(r, 500));
        randomPercent = randomIntegerInRange(30, 100);
        altWidth = (maxWidth * randomPercent) / 100;
        await next({ width: altWidth });
      }
    },
    from: {
      width: maxWidth
    }
  });
  return <animated.rect y={y} {...spring} height="14" rx="7" />;
};

export default BootRect;
